import React from 'react'
import Button from "../Button";
import {RefreshIcon} from "@heroicons/react/solid";
import {CursorClickIcon, ExclamationCircleIcon} from "@heroicons/react/outline";

// Types ----

type ErrorBoundaryFallbackProps = {
  error: Error
  componentStack: string
  eventId: string
  resetError(): void
}

// Component ----

export default function ErrorBoundaryFallback({resetError}: ErrorBoundaryFallbackProps) {
  return (
    <main>
      <section className='flex flex-col items-center justify-center flex-1 h-screen'>
        <ExclamationCircleIcon className='text-brand' width={48} height={48} />

        <h1 className='mt-4 text-brand font-medium text-2xl'>Something went wrong!</h1>

        <p className='text-gray-500 mt-4'>We're working on fixing the problem, please try again or reload the page.</p>

        <div className='flex flex-col gap-3 mt-8'>
          <Button color={Button.colors.PRIMARY} icon={CursorClickIcon} onClick={() => resetError()}>Try again</Button>
          <Button color={Button.colors.PRIMARY} icon={RefreshIcon} onClick={() => window.location.reload()}>Reload page</Button>
        </div>
      </section>
    </main>
  );
}